import { render, staticRenderFns } from "./InsuranceMaintenance.vue?vue&type=template&id=237dbdc4&scoped=true&"
import script from "./InsuranceMaintenance.vue?vue&type=script&lang=js&"
export * from "./InsuranceMaintenance.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "237dbdc4",
  null
  
)

export default component.exports